import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/notifications/unread', { params });
  },
  read(data) {
    return axios.put('/v1/notifications/read', data);
  }
};
